export default __webpack_public_path__ + "static/media/home-bg-three.d16facdc.avif";